import axiosInstance from './axiosInstance'

export const getVerticalSupportOptionById = (optionId) => {
  return axiosInstance.get(`/vertical-support-options/${optionId}`)
}

export const getVerticalSupportOptions = (page = 1, limit = 50, search = '', orderByKey = 'id', direction = 'asc', category = '') => {
  return axiosInstance.get(`/vertical-support-options?page=${page}&limit=${limit}&search=${search}&orderByKey=${orderByKey}&direction=${direction}${category ? `&category=${category}` : ''}`)
}

export const createVerticalSupportOption = (data) => {
  return axiosInstance.post('/vertical-support-options', data)
}

export const updateVerticalSupportOption = (optionId, data) => {
  return axiosInstance.put(`/vertical-support-options/${optionId}`, data)
}

export const deleteVerticalSupportOption = (optionId) => {
  return axiosInstance.delete(`/vertical-support-options/${optionId}`)
}
